import {
  getColorSync,
  getSwatchesSync,
} from 'colorthief';

function dominantColor(image: HTMLImageElement) {
  const color = getColorSync(image);
  /* const swatches = getSwatchesSync(image);
  const color = swatches.DarkMuted?.color; */

  if (
    !color
  ) return;

  const rgb = color.array().join(',');

  return (
    `linear-gradient(
      135deg,
      rgba(${rgb}, 0.065) 0%,
      rgba(${rgb}, 0.135) 100%
    )`
  );
};

export default dominantColor;
